import Validator from '../validator';

const codeMustBeTenCharacters = state => state.length === 10;

const StartApplicationValidator = new Validator([
  {
    field: 'producer',
    method: 'isEmpty',
    validWhen: false,
    message: 'Required field. Please select a HUB Producer.',
  },
  {
    field: 'csr',
    method: 'isEmpty',
    validWhen: false,
    message: 'Required field. Please select a HUB Account Manager.',
  },
  {
    field: 'branch',
    method: 'isEmpty',
    validWhen: false,
    message: 'Required field. Please select a HUB Branch.',
  },
  {
    field: 'profitCenter',
    method: 'isEmpty',
    validWhen: false,
    message: 'Required field. Please select a HUB Profit Center.',
  },
  {
    field: 'code',
    method: 'isEmpty',
    validWhen: false,
    message: 'Required field, please complete.',
  },
  {
    field: 'code',
    method: codeMustBeTenCharacters,
    validWhen: true,
    message: 'EPIC Client Code must be 10 character.',
  },
  {
    field: 'profession',
    method: 'isEmpty',
    validWhen: false,
    message: 'Profession is required.',
  },
]);

export default StartApplicationValidator;
